import { useEffect } from 'react';

// Per-page SEO. Updates the <head> tags in place (single source of truth) so the
// per-page title/description/canonical replace index.html defaults instead of
// duplicating them. JSON-LD blocks are injected and cleaned up on change/unmount.
const SITE = 'https://dyssc.com';
const DEFAULT_OG = `${SITE}/api/static/brand/og_share.png`;

function setMeta(attr, key, content) {
  if (content == null) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function setLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

export function Seo({ title, description, canonical, image, jsonLd }) {
  const ldKey = jsonLd ? JSON.stringify(jsonLd) : '';
  useEffect(() => {
    const url = canonical ? (canonical.startsWith('http') ? canonical : `${SITE}${canonical}`) : SITE;
    const ogImage = image ? (image.startsWith('http') ? image : `${SITE}${image}`) : DEFAULT_OG;
    if (title) document.title = title;
    // Robots must stay indexable: bot traffic is served via prerender under an internal hostname,
    // so hostname-based noindex logic would leak into the snapshot Google sees. Canonicals handle mirrors.
    setMeta('name', 'robots', 'index, follow, max-image-preview:large');
    setMeta('name', 'description', description);
    setLink('canonical', url);
    setMeta('property', 'og:title', title);
    setMeta('property', 'og:description', description);
    setMeta('property', 'og:url', url);
    setMeta('property', 'og:image', ogImage);
    setMeta('name', 'twitter:title', title);
    setMeta('name', 'twitter:description', description);
    setMeta('name', 'twitter:image', ogImage);

    // Remove any pre-existing dynamic JSON-LD first (prerendered snapshots bake these
    // into the HTML; re-execution must replace them, not duplicate them for Google)
    document.head.querySelectorAll('script[data-seo="dynamic"]').forEach((n) => n.remove());
    const parsed = ldKey ? JSON.parse(ldKey) : [];
    const arr = Array.isArray(parsed) ? parsed : [parsed];
    const nodes = arr.filter(Boolean).map((obj) => {
      const s = document.createElement('script');
      s.type = 'application/ld+json';
      s.setAttribute('data-seo', 'dynamic');
      s.text = JSON.stringify(obj);
      document.head.appendChild(s);
      return s;
    });
    return () => nodes.forEach((n) => n.remove());
  }, [title, description, canonical, image, ldKey]);

  return null;
}

export const ErneSeo = ({ path = '/erne' }) => (
  <Seo
    title="THE ERNE by DYSSC | Pickleball Ambassador Program"
    description="Play DYSSC. Earn your paddle. Apply now."
    canonical={path}
    image="/api/static/brand/erne_og_share.jpg"
  />
);
